export default __webpack_public_path__ + "static/photoGalleryModule_cloud_bottom-f409355d38ba0bd8e5bca1003dbe7dd1.webp";